function TimelineIntro() {
  return null;
}

export default TimelineIntro;
